/** Shared "why" reason codes for a thumbs-down on either AI chat engine (Linc/KB chat, Linc Data)
 *  — added 2026-08-23 alongside the new SUPER_ADMIN/ROOT AI chat review screen. Imported by both
 *  the live chat widget (ai-chat-widget.component.ts, to render the reason chips) and the future
 *  admin review screen (to render the reason-breakdown chart), so the label text never drifts
 *  between the two. `code` values must match the backend's FeedbackReasonCode enum's `.name()`
 *  strings exactly (tms-sb/src/main/java/com/ll/tms/ai/entity/FeedbackReasonCode.java). */
export interface FeedbackReason {
  code: string;
  label: string;
}

export const FEEDBACK_REASONS: FeedbackReason[] = [
  { code: 'WRONG_ANSWER', label: 'Wrong answer' },
  { code: 'MISUNDERSTOOD_QUESTION', label: 'Misunderstood my question' },
  { code: 'INCOMPLETE', label: 'Incomplete' },
  { code: 'TOO_SLOW', label: 'Too slow' },
  { code: 'NOT_HELPFUL', label: 'Not helpful' },
  { code: 'OTHER', label: 'Other' },
];
